import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { Message } from 'src/app/core/class/message';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';

@Component({
  selector: 'app-handle-transaction-detail-dialog',
  templateUrl: './handle-transaction-detail-dialog.component.html',
  styleUrls: ['./handle-transaction-detail-dialog.component.scss']
})
export class HandleTransactionDetailDialogComponent implements OnInit {

  displayedColumns: string[] = [];

  columnDefinitions = [
    { def: "STT", showXS: true, showSM: true, showMD: true },
    { def: "signType", showXS: true, showSM: true, showMD: true },
    { def: "status", showXS: false, showSM: false, showMD: false },
    { def: "endDate", showXS: false, showSM: false, showMD: false },
    { def: "errorType", showXS: false, showSM: false, showMD: false },
    { def: "errorCode", showXS: false, showSM: false, showMD: false },
    { def: "updateDate", showXS: false, showSM: false, showMD: false },
  ];

  displayedChildColumns: string[] = [
    'STT',
    'signType',
    'status',
    'endDate',
    'errorType',
    'errorCode',
    'updateDate'
  ];

  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  constructor(
    public dialogRef: MatDialogRef<HandleTransactionDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: Message
  ) { 
    this.getDisplayedColumns();
  }

  ngOnInit() {
  }

  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }
    }
  }

  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('down_sign_transaction.status_error');
      case 'DONE':
        return this.message.getMessage('down_sign_transaction.status_done');
      case 'PROCESSING':
        return this.message.getMessage('down_sign_transaction.status_processing');
      default:
        return '';
    }
  }

  renderType(type: string) {
    switch (type) {
      case 'NORMAL':
        return this.message.getMessage('down_sign_transaction.type_normal');
      case 'CECA':
        return this.message.getMessage('down_sign_transaction.type_ceca');
      case 'MOIT':
        return this.message.getMessage('down_sign_transaction.type_moit');
      default:
        return '';
    }
  }

  renderError(type: string) {
    switch (type) {
      case 'BY_USER':
        return this.message.getMessage('down_sign_transaction.by_user');
      case 'BY_SYSTEM':
        return this.message.getMessage('down_sign_transaction.by_system');
      case 'BY_MOIT':
        return this.message.getMessage('down_sign_transaction.by_moit');
      default:
        return '';
    }
  }

  close(){
    this.dialogRef.close()
  }

}
